import React from "react";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { RecoilRoot } from "recoil";

import { MxContextProvider } from "@soluto-private/mx-context-react";
import { AppContainer } from "@trailhead/core-ui";
import { GlobalStyles, BetaContext } from "@trailhead/asurion-ui";
import { ContentfulConfiguredI18n } from "@trailhead/i18n";
import Routes from "./routes";

import "@trailhead/core-ui/css/global-styles.css";

const withProviders = (AppComp: React.FC) => () => {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient} contextSharing={true}>
      <BrowserRouter>
          <GlobalStyles />
          <MxContextProvider>
            <RecoilRoot>
              <BetaContext.Provider value={{ useIconBeta: true }}>
                <ContentfulConfiguredI18n fallbackComponent={null}>
                  <AppComp />
                </ContentfulConfiguredI18n>
              </BetaContext.Provider>
            </RecoilRoot>
          </MxContextProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
};

const App: React.FC = () => (
  <AppContainer>
    <Routes />
  </AppContainer>
);

export default withProviders(App);
